import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    width: '100%',
    maxWidth: 260,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      minWidth: 300,
    },
    [theme.breakpoints.down('lg')]: {
      minWidth: 250,
      maxWidth: '100%',
      margin: '0 auto',
    },
  },
  totalTitle: {
    fontSize: 16,
    lineHeight: 1.5,
    marginTop: 28,
    letterSpacing: -0.7,
  },
  totalValue: {
    fontSize: 22,
    lineHeight: 1.36,
    fontFamily: 'Montserrat-Bold',
    marginTop: 12,
    marginBottom: 28,
  },
}));
